var _path, _rect, _rect2, _rect3, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeyActivated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73901 0.999999C3.12172 1.00007 0.999756 3.12195 0.999755 5.73926C0.999824 8.35651 3.12177 10.4784 5.73901 10.4785C8.35632 10.4785 10.4782 8.35655 10.4783 5.73926C10.4783 3.12191 8.35636 1 5.73901 0.999999Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.478261,
    y: 0.478261,
    width: 0.956521,
    height: 9.56522,
    rx: 0.478261,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 5.73916 10.5217)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.956521
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.478261,
    y: 0.478261,
    width: 0.956522,
    height: 2.86957,
    rx: 0.478261,
    transform: "matrix(-5.86359e-08 1 1 5.86359e-08 5.73914 14.3478)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.956522
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.478261,
    y: 0.478261,
    width: 0.956522,
    height: 2.86957,
    rx: 0.478261,
    transform: "matrix(-5.86359e-08 1 1 5.86359e-08 5.73914 17.2174)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.956522
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1739 9.56525V17.2174",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3478 13.3913H22",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0.956522,
    cy: 0.956522,
    r: 0.956522,
    transform: "matrix(-1 0 0 1 6.69562 4.78265)",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyActivated);
export default __webpack_public_path__ + "static/media/key_activated.5e46c339f76377b189dff95112f5aaa0.svg";
export { ForwardRef as ReactComponent };